import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.765 2.607H3.5c-.828 0-1.5.616-1.5 1.375v8.25c0 .76.672 1.375 1.5 1.375h3.407c1.822.334 3.439 2.09 3.439 3.725v4.638l.97.028c.052.002.094.002.166.002 2.036 0 2.955-.934 2.955-3.591v-3.472h5.91c.622 0 1.187-.223 1.556-.674.353-.431.457-.987.341-1.554l-1.786-8.73c-.269-1.311-1.62-2.372-2.983-2.372H9c-.888 0-1.687.386-2.236 1zm14.5 10.302c.06.29.012.54-.136.72-.162.199-.44.308-.782.308h-6.91v4.472c0 2.411-.774 2.591-1.955 2.591l-.136-.001v-3.667c0-2.193-2.061-4.35-4.345-4.723V4.607a2 2 0 0 1 2-2h8.474c.895 0 1.832.735 2.004 1.572l1.786 8.73zM3.5 12.607c-.276 0-.5-.201-.5-.45v-8.1c0-.248.224-.45.5-.45h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2z"
});

var SvgThumbsDown = function SvgThumbsDown(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgThumbsDown;